import { put, call, take, fork } from 'redux-saga/effects'
import { AICreatorAddAttachmentUrlService } from '../../api/ai-creator'
import { aICreatorUploadAttachmentSuccess } from '../../reducers/ai-creator/action'
import { ADD_ATTACHMENT_URL } from '../../reducers/ai-creator/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* addAttachmentUrlFlow(payload) {
  try {
    const { req, callback } = payload

    const response = yield call(AICreatorAddAttachmentUrlService, req)

    // Reuse upload attachment success because the response structure and UI update (adding to list) are the same
    // Assuming backend returns the attachment object
    const finalResponse = {
      ...response,
      attachment_type: req.attachment_type || response.attachment_type
    }
    yield put(aICreatorUploadAttachmentSuccess(finalResponse, req.url)) 
    yield put(operationSuccess())
    if (callback) callback(finalResponse)
  } catch (error) {
    yield put(operationFail(error))
    const { callback } = payload
    if (callback) callback(null, error)
  }
}

/**
 *
 */
export default function* aICreatorAddAttachmentUrlWatcher() {
  while (true) {
    const action = yield take(ADD_ATTACHMENT_URL)
    const { payload } = action

    yield fork(generalSaga, addAttachmentUrlFlow, payload, false)
  }
}
